import { ContrastIcon } from 'lucide-react';
import { useRecoilState } from 'recoil';
import SplitToggleButton from '~/components/Buttons/SplitToggleButton';
import { selectedToolState } from '~/state/atoms/toolsAtoms';
import WindowingToolOptions from './WindowingToolOptions';

export default function WindowingTool() {
    const [tool, setTool] = useRecoilState(selectedToolState);
    return (
        <SplitToggleButton
            isSelected={tool === 'window'}
            value="window"
            onToggle={() => setTool('window')}
            icon={<ContrastIcon />}
            tooltipTitle="Window level"
            popperComponent={<WindowingToolOptions />}
        />
    );
}
